import { useEmailAction } from './useEmailAction';
import { useUserCommunicationsStore } from '../../../store';

export const useForwardUserCommunication = () => {
  const { setForwardLoading } = useUserCommunicationsStore();

  const { handleEmailAction } = useEmailAction(() => ({
    setLoading: setForwardLoading,
    successKey: 'inbox.userCommunication.actions.forwardSuccess',
    errorKey: 'inbox.userCommunication.actions.forwardError',
  }));

  return { handleForwardUserCommunication: handleEmailAction };
};
